import React, { Component, type ReactNode } from 'react';

import { Icon } from './Icon';

interface State {
  hasError: boolean;
  errorInfo: React.ErrorInfo | null;
}

interface Props {
  children: ReactNode;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    errorInfo: null,
    hasError: false,
  };

  constructor(props: Props) {
    super(props);
    this.state = { errorInfo: null, hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    console.error(error);
    return { errorInfo: null, hasError: true };
  }

  componentDidCatch(_: Error, errorInfo: React.ErrorInfo) {
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="d-flex flex-column items-center justify-center text-center"
          style={{
            backgroundColor: 'white',
            borderRadius: '0.25rem',
            height: '100vh',
            width: '100%',
          }}
        >
          <Icon name="NotFoundIllustration" className="mb-3" style={{ height: 200, width: 200 }} />
          <h1>Oops!</h1>
          <p style={{ lineHeight: '1.5', maxWidth: '40rem' }}>
            An error occurred while loading the page. Please try again.
            <br />
            If the problem persists, please contact support.
          </p>
          <div>
            <button
              className="btn btn-primary"
              onClick={() => {
                window.location.reload();
              }}
            >
              Reload page
            </button>
          </div>
        </div>
      );
    }

    // eslint-disable-next-line react/prop-types
    return this.props.children;
  }
}

export default ErrorBoundary;
